import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { fetchContractById } from '../../services/contractService';

const SharedContract = () => {
  const { id } = useParams();
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContract = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchContractById(id);
        setContract(data);
      } catch (err) {
        console.error('Failed to load contract:', err);
        setError('Contract niet gevonden. Controleer de link en probeer het opnieuw.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadContract();
    }
  }, [id]);

  return (
    <>
      <Helmet>
        <title>
          {contract?.contractTitle
            ? `${contract?.contractTitle} – Pactorae`
            : 'Contract – Pactorae'}
        </title>
        <meta
          name="description"
          content="Bekijk dit contract gegenereerd met Pactorae."
        />
      </Helmet>
      <div
        style={{
          minHeight: '100vh',
          backgroundColor: '#f3f4f6',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Main content */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            padding: '48px 16px',
          }}
        >
          {loading && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
                color: '#6b7280',
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  border: '3px solid #e5e7eb',
                  borderTop: '3px solid #2F4E6F',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
              <p style={{ fontSize: '16px' }}>Contract laden...</p>
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          )}

          {!loading && error && (
            <div
              style={{
                maxWidth: '600px',
                width: '100%',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '48px',
                textAlign: 'center',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
              }}
            >
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📄</div>
              <h1
                style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#111827',
                  marginBottom: '12px',
                }}
              >
                Contract niet gevonden
              </h1>
              <p style={{ color: '#6b7280', marginBottom: '24px' }}>{error}</p>
              <Link
                to="/contract-generator"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#2F4E6F',
                  color: '#ffffff',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                }}
              >
                Maak jouw contract
              </Link>
            </div>
          )}

          {!loading && !error && contract && (
            <div
              style={{
                maxWidth: '800px',
                width: '100%',
              }}
            >
              {/* Contract paper */}
              <div
                id="contract-preview"
                style={{
                  backgroundColor: '#ffffff',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                  maxWidth: '800px',
                  width: '100%',
                  padding: '48px',
                  minHeight: '1000px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '4px',
                }}
              >
                <div
                  style={{
                    fontFamily: 'Georgia, "Times New Roman", serif',
                    fontSize: '12pt',
                    lineHeight: '1.6',
                    color: '#000000',
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                  }}
                >
                  {contract?.contractText}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer bar */}
        <div
          style={{
            backgroundColor: '#1f2937',
            color: '#d1d5db',
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            flexWrap: 'wrap',
            textAlign: 'center',
          }}
        >
          <span style={{ fontSize: '14px' }}>
            Gegenereerd met{' '}
            <strong style={{ color: '#ffffff' }}>Pactorae</strong>
            {' – '}Maak professionele contracten in seconden
          </span>
          <Link
            to="/contract-generator"
            style={{
              backgroundColor: '#FF8C00',
              color: '#ffffff',
              padding: '8px 20px',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px',
              whiteSpace: 'nowrap',
            }}
          >
            Maak jouw contract
          </Link>
        </div>
      </div>
    </>
  );
};

export default SharedContract;
